let language = {
    PRIVACY_POLICY_AGREE_PROCESSED_TEXT: "我同意按照以下规定处理我的数据",
    PRIVACY_POLICY_HAVE_READ_TEXT: "我已经阅读并且同意",
};

export { language }